import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import { IconButton, Drawer, Modal, TextField, MenuItem, Slide  } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
import {
  Root,
  AppBar,
  AppMenuBar,
  OverlayMenu,
  CloseDrawerButton,
  Logo,
  LogoContainer,
  Menu,
  MenuButton,
  Content,
  Container,
  AppBarContainer,
  AppFooterBar,
  AppFooterContainer,
  LogoPrevic,
  LogoDataA,
  ModalBody,
  ModalCloseButton,
  AppBarItem
} from './styles';
import Beneficiarios from "./Beneficiarios";
import Simulador from "./Simulador";
import MeusDados from "./MeusDados";
import MeuPlano from "./MeuPlano";
import MeuPlanoAlterarContribuicao from "./MeuPlanoAlterarContribuicao";
import MeuPlanoAlterarBeneficio from "./MeuPlanoAlterarBeneficio";
import MeuPlanoContracheque from "./MeuPlanoContracheque";
import { Col } from "react-bootstrap";
import LoadingStatus from "components/LoadingStatus";
import { SnackbarProvider } from 'notistack';
import { logout, updateUserData } from 'services/ducks/auth';
import Transparencia from "./Transparencia";
import Emprestimos from "./Emprestimos";

import api from "services/structure/api";

class App extends Component {

  state = {
    openMenu: false,
    openModalTrocaPlano: false,
    regrasExibicao: {
      exibirAbaSimulador: false
    }
  }

  componentDidUpdate(prevProps){
    if (this.state.id !== prevProps.authData.usuario.pessoa.id) {
      this.setState({ id : prevProps.authData.usuario.pessoa.id })
      this.buscarTodosOsDados();
    }
  }

  componentDidMount() {
    this.buscarTodosOsDados();

  }

  buscarTodosOsDados() {
    const regrasExibicaoPromise = this.buscarRegrasExibicao();

    const promises = [];
    promises.push(regrasExibicaoPromise);
    Promise.all(promises)
      .then(values => {
        const newState = Object.assign(...values);
        this.setState(newState);
      })
      .catch(e => {
        console.log(e);
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: "error" });
      })
      .finally();
  }

  buscarRegrasExibicao() {
    return api.get("meu-plano/regras-exibicao")
      .then(response => {
        console.log(response)
        const {
          exibirAbaSimulador
        } = response.data;
        return {
          regrasExibicao: {
            exibirAbaSimulador }};
      })
      .catch((err) => console.error("err buscarRegrasExibicao : " + err));
  }




  toggleDrawer = () => {
    this.setState({ openMenu: !this.state.openMenu })
  }

  closeDrawer = () => {
    this.setState({ openMenu: false })
  }

  logout = () => {
    this.props.logout();
    this.props.history.push("/");
  }

  changeParticipantePlano = (usuario) => {
    const authData = this.props.authData;
    authData.usuario.pessoa = usuario;
    authData.token = usuario.token;
    this.setState({ openModalTrocaPlano: false });
    this.props.updateUserData(authData);
    this.props.history.push("/app/");
  }

  renderMenuTrocaPlano = () => {
    const authData = this.props.authData;
    const itemsMenu = [];
    const loginsSecundarios = authData.usuario?.loginsSecundarios?.login;
    if (loginsSecundarios) {
      for (let i = 0; i < loginsSecundarios.length; i++) {
        const usuario = loginsSecundarios[i];
        itemsMenu.push(
          <MenuItem onClick={e => this.changeParticipantePlano(usuario)} key={i}>
            {usuario.nomePlano}
          </MenuItem>
        );
      }
    }
    return <TextField
      variant="outlined"
      margin="normal"
      fullWidth
      select={true}
      SelectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          getContentAnchorEl: null
        }
      }}>
      {itemsMenu}
    </TextField>;
  }

  renderAppBarDesktop() {
    const authData = this.props.authData;
    return <AppBarContainer className={`app-bar-container row ${this.props.className}`}>
      {this.renderAppBarItemApresentacao()}
      <AppBarItem sm={4} className="app-bar-header-item-situacao-previdenciaria">
        <span className="item-value-center">
          <span className="item-name">Situação Previdenciária: </span>
          <span className="item-value">{authData.usuario.pessoa.situacaoPrevidenciaria}</span>
        </span>
      </AppBarItem>
      {this.renderAppBarItemTrocaPlano()}
    </AppBarContainer>
  }

  renderAppBarTablet() {
    return <AppBarContainer className={`app-bar-container row ${this.props.className}`}>
      <div className="tablet-menu-container row">
        {this.renderAppBarItemApresentacao()}
        {this.renderAppBarItemTrocaPlano()}
      </div>
    </AppBarContainer>
  }

  renderAppBarMobileOnly() {
    return <AppBarContainer className={`app-bar-container row ${this.props.className}`}>
      {this.renderAppBarItemTrocaPlano()}
    </AppBarContainer>
  }

  renderAppBarItemApresentacao() {
    const authData = this.props.authData;
    return <AppBarItem className="app-bar-item-nome" sm={isTablet ? 6 : 4}>
      <OverlayMenu className="app-bar">
        <span className="item-value">Olá, </span>
        <span className="item-name">{authData.usuario.pessoa.nome}</span>
        <span className="item-value">!</span>
      </OverlayMenu>
    </AppBarItem>
  }

  renderAppBarItemTrocaPlano() {
    const authData = this.props.authData;
    return <AppBarItem
      sm={isMobile ? 6 : 4}
      onMouseOver={e => this.setState({ anchorElMenu: e.currentTarget })}
      onMouseLeave={() => this.setState({ menuPlanoOpen: null })} 
      className="app-bar-header-item-troca-plano">
      <OverlayMenu className="app-bar" onClick={() => this.openModalTrocaPlanoOnClick()}>
        <span className="item-name">Plano: </span>
        <span className="item-value">{authData.usuario.pessoa.nomePlano}</span>
        &nbsp;<i className="fas fa-random"></i>
      </OverlayMenu>
    </AppBarItem>
  }

  openModalTrocaPlanoOnClick() {
    const authData = this.props.authData;
    const loginsSecundarios = authData.usuario?.loginsSecundarios?.login;
    if (loginsSecundarios) {
      this.setState({ openModalTrocaPlano: true })
    }
  }

  navigateTo(route) {
    this.props.history.push(route);
    this.closeDrawer();
  }

  renderMenu() {
    const authData = this.props.authData;
    return <Menu>
      <MenuButton className={`app-menu-item-meu-plano ${this.props.className}`} onClick={() => this.navigateTo('/app/meu-plano')}>Meu Plano</MenuButton>
      <MenuButton className={`app-menu-item-meus-dados ${this.props.className}`} onClick={() => this.navigateTo('/app/meus-dados')}>Meus Dados</MenuButton>
      <MenuButton className={`app-menu-item-beneficiarios ${this.props.className}`} onClick={() => this.navigateTo('/app/beneficiarios')}>Beneficiários</MenuButton>
      {/*
      <MenuButton className={`app-menu-item-emprestimos ${this.props.className}`} onClick={() => this.navigateTo('/app/emprestimos')}>Empréstimos</MenuButton>
      */}
      { this.state.regrasExibicao.exibirAbaSimulador &&
        <MenuButton className={`app-menu-item-simulador ${this.props.className}`} onClick={() => this.navigateTo('/app/simulador')}>Simulador</MenuButton>
      }
      <MenuButton className={`app-menu-item-simulador ${this.props.className}`} onClick={() => this.navigateTo('/app/emprestimos')}>Emprestimos</MenuButton>
      <MenuButton className={`app-menu-item-governanca ${this.props.className}`} onClick={() => this.navigateTo('/app/transparencia')}>Transparência</MenuButton>
      {/* <MenuButton className={`app-menu-item-contato ${this.props.className}`} onClick={() => this.navigateTo('/app/contato')}>Contato</MenuButton> */}
      <MenuButton className={`app-menu-item-sair ${this.props.className}`} onClick={this.logout}>Sair</MenuButton>
      {isMobile &&
        <div className="drawer-separator">
          <div className="drawer-label">
            <span className="item-name">Situação Previdenciária: </span>
            <span className="item-value">{authData.usuario.pessoa.situacaoPrevidenciaria}</span>
          </div>
        </div>
      }
    </Menu>
  }

  render() {
    return (
      <Root className={`app ${isMobile ? 'mobile-root' : 'desktop-root'} ${isMobileOnly ? 'mobile-only-root' : ''} ${isTablet ? 'tablet-root' : ''}`} maxSsnack={3}>
        <SnackbarProvider maxSnack={5}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            TransitionComponent={Slide}>
          <Modal open={this.state.openModalTrocaPlano}>
            <div className="modal-troca-plano">
              <ModalBody>
                <h4>
                  Escolha o <b>Plano</b>:
                  <div className="close-modal-position">
                    <ModalCloseButton className="close-modal-button" onClick={() => this.setState({ openModalTrocaPlano: false })}>X</ModalCloseButton>
                  </div>
                </h4>
                {this.renderMenuTrocaPlano()}
              </ModalBody>
            </div>
          </Modal>
          <AppMenuBar className={`app-menu-bar row ${this.props.className}`}>
            <AppBarContainer className={`app-menu-bar-container ${this.props.className}`}>
              <LogoContainer>
                <Logo src={this.props.imageLogoUrl} alt="Logo" className="img-logo" />
              </LogoContainer>
              {!isMobile && this.renderMenu()}
              {isMobile &&
                <span className="menu-mobile">
                  <IconButton onClick={this.toggleDrawer}>
                    <MenuIcon />
                  </IconButton>
                  <Drawer
                    anchor="left"
                    open={this.state.openMenu}
                    className={` ${isMobileOnly ? "mobile-drawer" : "tablet-drawer"}  `}>
                    <CloseDrawerButton
                      className="close-drawer-button"
                      onClick={this.closeDrawer}>X</CloseDrawerButton>
                    {this.renderMenu()}
                  </Drawer>
                </span>
              }
            </AppBarContainer>
          </AppMenuBar>
          <AppBar className="app-bar">
            {!isMobile && this.renderAppBarDesktop()}
            {isTablet && this.renderAppBarTablet()}
            {isMobileOnly && this.renderAppBarMobileOnly()}
          </AppBar>
          <Content>
            <Container className={`app-container ${this.props.className}`}>
              <Route path="/app/meu-plano" component={MeuPlano} />
              <Route path="/app/meu-plano-alterar-contribuicao" component={MeuPlanoAlterarContribuicao} />
              <Route path="/app/meu-plano-alterar-beneficio-cd" component={MeuPlanoAlterarBeneficio} />
              <Route path="/app/meu-plano-contracheque" component={MeuPlanoContracheque} />
              <Route path="/app/meus-dados" component={MeusDados} />
              <Route path="/app/beneficiarios" component={Beneficiarios} />
              <Route path="/app/emprestimos" component={Emprestimos} />
              <Route path="/app/simulador" component={Simulador} />
              <Route path="/app/transparencia" component={Transparencia} />
              <Route path="/app/contato" component={Beneficiarios} />
              <Route exact path="/app/" component={MeuPlano} />
            </Container>
          </Content>
          <AppFooterBar className="app-footer">
            <AppBarContainer className={`app-bar-container row ${this.props.className}`}>
              <AppFooterContainer className="row">
                <Col sm={3}>
                  <Logo src={this.props.imageLogoUrl} alt="Logo" className="img-logo" />
                </Col>
                <Col sm={5}>
                  <div dangerouslySetInnerHTML={{ __html: this.props.descricao }} className="app-descricao-entidade"></div>
                </Col>
                <Col sm={4} className={isMobile ? "mobile-footer-logos" : ""}>
                  <LogoPrevic src={process.env.PUBLIC_URL + '/logo-previc.png'} alt="Previc" className="img-logo-previc" />
                  <LogoDataA src="https://www.dataa.com.br/wp-content/uploads/2021/03/Data-A-Soluc%CC%A7o%CC%83es-150x62.png" alt="Data A" className="img-logo-dataa" />
                </Col>
              </AppFooterContainer>
            </AppBarContainer>
          </AppFooterBar>
          <LoadingStatus className="loading-status" />
        </SnackbarProvider>
      </Root>
    )
  }

}

const mapStateToProps = store => ({
  authData: store.authState,
  imageLogoUrl: store.layoutState.imageLogoUrl,
  descricao: store.layoutState.descricao
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, updateUserData }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));